import { DatePeriod } from '../../types/date-period.type';

export class DateFilterModel {
  public dateNumber?: number;
  public datePeriod?: DatePeriod;
  public date?: Date;
  public startDate?: string | Date;
  public endDate?: string | Date;
}
